<div class="w-[calc(100%-64px)]">
  <aura-phone-number-input
    [control]="phoneControl"
    [required]="true"
    label="Numéro de téléphone portable"
    (numberChanged)="onNumberChanged($event)"
  />
</div>
